import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { PaymentMethodPgType } from '@/payment/types'

/**
 * 결제수단 등록 — POST /payments/methods.
 *
 * NICEPAY 직접 입력(개인/법인) 이번 phase 사용. 카카오페이 간편등록은 다음 phase.
 * apidog 응답: { data: { paymentMethodId } } (NICEPAY) — 응답 어댑터에서 unwrap.
 *
 * 에러 코드는 ApiError.code로 처리 — errorMap.ts 참조 (E409300/E422301~304/E422314/E503301).
 */
export type IdentificationType = 'PERSONAL' | 'BUSINESS'

export interface NicepayCardDetail {
  identificationType: IdentificationType
  cardNo: string
  expYear: string
  expMonth: string
  idNo: string
  cardPw: string
}

/**
 * 결제수단 등록 body — NICEPAY(폼 직접 입력) / KAKAOPAY(detail null, redirect 흐름) union.
 *
 * KAKAOPAY 는 `nextRedirectMobileUrl` 등 redirect 정보를 응답으로 받아
 * 사용자를 카카오로 보내고, 인증 완료 후 백엔드 콜백으로 `paymentMethodId` 발급.
 */
export type PostPaymentMethodBody =
  | {
      paymentMethodType: 'CARD'
      pgType: Extract<PaymentMethodPgType, 'NICEPAY'>
      isQuickRegistered: false
      detail: NicepayCardDetail
    }
  | {
      paymentMethodType: 'CARD'
      pgType: Extract<PaymentMethodPgType, 'KAKAOPAY'>
      isQuickRegistered: true
      detail: null
    }

export interface PostPaymentMethodResponse {
  /** NICEPAY 즉시 등록 완료 시. KAKAOPAY 는 콜백 이후 별도 fetch 로 확인 */
  paymentMethodId?: number
  /** KAKAOPAY — 카카오페이 거래 ID */
  tid?: string
  /** KAKAOPAY — 모바일 redirect URL */
  nextRedirectMobileUrl?: string
  /** KAKAOPAY — PC redirect URL (참고) */
  nextRedirectPcUrl?: string
  /** KAKAOPAY — 카카오톡 앱 redirect URL (참고) */
  nextRedirectAppUrl?: string
  /** KAKAOPAY — Android 카카오톡 deep link */
  androidAppScheme?: string
  /** KAKAOPAY — iOS 카카오톡 deep link */
  iosAppScheme?: string
}

export const apiPostPaymentMethod = async (body: PostPaymentMethodBody): Promise<PostPaymentMethodResponse> => {
  return api.post(`${API_PREFIX.PAYMENT}/payments/methods`, body)
}
